import { makeStyles } from '@material-ui/core';

import accionaLogoSmall from './logo/acciona_logo_small.png';
import accionaLogoSmallRed from './logo/acciona_logo_small_red.png';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 75,
  },
  path: {
    fill: '#7df3e1',
  },
});

export const LogoIconAcciona = () => {
  const themeApi = useApi(appThemeApiRef);
  const themeId = themeApi.getActiveThemeId();

  const logo =
    themeId === 'accionaDarkTheme'
      ? accionaLogoSmall
      : accionaLogoSmallRed;
  const classes = useStyles();
  return <img src={logo} alt="Acciona Logo" className={classes.svg} />;
};

